module.exports = __webpack_public_path__ + "img/p30.0f805c73.svg";